<template>
  <el-dialog
    :title="$t('newApp.Attribute.breakdownAdvertising')"
    :visible.sync="dialogVisible"
    width="1000px"
    class="advertCostDialog"
    @close="dialogCloseHandle"
  >
    <div v-for="(item, i) in rowData" :key="i">
      <div
        class="common_readonly_template"
      >
        <el-row>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <div>
              <div class="label">{{ $t('newApp.Attribute.OrderNumber') }}</div>
              <div class="text">{{ item.prodCode }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <div>
              <div class="label">{{ $t('newApp.Attribute.TotalCcosts') }}</div>
              <div class="text">{{ item.odrAmount }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table
        class="table-container"
        :header-cell-style="{background: '#F6F7F9', fontWeight: 'normal', color: '#5B646E'}"
        :data="item.productList"
        border
        style="width: 100%"
      >
        <el-table-column prop="productName" :label="$t('newApp.ADList.noa')" />
        <el-table-column prop="unitprice" :label="$t('newApp.ADList.up')" />
        <el-table-column prop="buynum" :label="$t('newApp.Attribute.nop')" />
        <el-table-column prop="osubAmount" :label="$t('newApp.Attribute.sp')" />
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {}
    };
  },
  props: {
    advertCostDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    advertCostDialogVisible (val) {
      this.dialogVisible = val;
    }
  },
  methods: {
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>
<style lang="scss" scoped>
.common_readonly_template {
  margin-bottom: 10px;
  .val > span {
    margin-left: 20px;
    color: #3384fe;
    cursor: pointer;
  }
}
.table-container {
  margin-bottom: 30px;
}
</style>
